import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { saveAs } from 'file-saver';
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";
import { setPageData } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";

const ActiveJobSummary = () => {

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    document.title = "ATS - Reports"
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);

    const handleCompanyChange = (item) => {

        if (item?.company_id) {

            setCompanyId(item.company_id);

            setFirst(0); // reset pagination

        }

    };

    const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    openings: { value: null, matchMode: FilterMatchMode.EQUALS },
    Interview: { value: null, matchMode: FilterMatchMode.EQUALS },
    Submitted: { value: null, matchMode: FilterMatchMode.EQUALS },
    Received: { value: null, matchMode: FilterMatchMode.EQUALS },
    Potential: { value: null, matchMode: FilterMatchMode.EQUALS },
    Offer: { value: null, matchMode: FilterMatchMode.EQUALS },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    owner_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
});

    const [jobs, setJobs] = useState([]);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const dt = useRef(null);
    const toast = useRef(null);

    // Define column configuration
    const columnConfig = [
        { field: "job_number", header: "Job Id", sortable: true, filter: true, filterPlaceholder: "Filter by Job Id", style: { minWidth: '10rem' } },
        { field: "job_title", header: "Job Title", sortable: true, filter: true, filterPlaceholder: "Filter by Job Title", style: { minWidth: '10rem' } },
        { field: "priority", header: "Priority", sortable: true, filter: true, filterPlaceholder: "Filter by Priority", style: { minWidth: '10rem' } },
        { field: "openings", header: "Openings", sortable: true, filter: true, filterPlaceholder: "Filter by Openings", style: { minWidth: '10rem' } },
        // { field: "shortlisted", header: "Shortlisted", sortable: true, filter: true, filterPlaceholder: "Filter by Shortlisted", style: { minWidth: '10rem' } },
        { field: "Interview", header: "Interview", sortable: true, filter: true, filterPlaceholder: "Filter by Interviews", style: { minWidth: '10rem' } },
        { field: "Submitted", header: "Submitted", sortable: true, filter: true, filterPlaceholder: "Filter by Submitted", style: { minWidth: '10rem' } },
        { field: "Received", header: "Received", sortable: true, filter: true, filterPlaceholder: "Filter by Received", style: { minWidth: '10rem' } },
        { field: "Potential", header: "Potential", sortable: true, filter: true, filterPlaceholder: "Filter by Potential", style: { minWidth: '10rem' } },
        { field: "Offer", header: "Offer", sortable: true, filter: true, filterPlaceholder: "Filter by Offers", style: { minWidth: '10rem' } },

        {
            field: "start_date",
            header: "Start Date",
            sortable: true,
            filter: true,
            filterPlaceholder: "Filter by Start Date",
            filterElement: (options) => (
                <Calendar
                    value={options.value}
                    onChange={(e) => options.filterApplyCallback(e.value)}
                    dateFormat="yy-mm-dd"
                    placeholder="YYYY-MM-DD"
                    showButtonBar
                />
            ),
            body: (rowData) => rowData.start_date ? `${rowData.start_date.getFullYear()}-${String(rowData.start_date.getMonth() + 1).padStart(2, '0')}-${String(rowData.start_date.getDate()).padStart(2, '0')}` : '-',
            style: { minWidth: '10rem' }
        },
        {
            field: "start_date",
            header: "End Date",
            sortable: true,
            filter: true,
            filterPlaceholder: "Filter by End Date",
            filterElement: (options) => (
                <Calendar
                    value={options.value}
                    onChange={(e) => options.filterApplyCallback(e.value)}
                    dateFormat="yy-mm-dd"
                    placeholder="YYYY-MM-DD"
                    showButtonBar
                />
            ),
            body: (rowData) => rowData.end_date ? `${rowData.end_date.getFullYear()}-${String(rowData.end_date.getMonth() + 1).padStart(2, '0')}-${String(rowData.end_date.getDate()).padStart(2, '0')}` : '-',
            style: { minWidth: '10rem' }
        },
        { field: "owner_id", header: "Recruiter Name", sortable: true, filter: true, filterPlaceholder: "Filter by Recruiter Name", style: { minWidth: '10rem' } }
    ];


    const onSelectionChange = (e) => {
        setSelectedJobs(e.value);
    };

    const fetchActiveJobSummaryResults = async (page, size=10) => {
        setLoading(true);
        try {
            // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/job_summary_report/?page=${page}&size=${rows}`);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/job_summary_report/?page=${page}&size=${size}&company_id=${companyId}`);
            if (response.status === 200) {
                const apiResponse = response?.data?.results?.map(job => {
                    let startDate = job.job_start_date ? new Date(job.job_start_date) : null;
                    if (startDate && isNaN(startDate.getTime())) startDate = null;
                    let endDate = job.job_end_date ? new Date(job.job_end_date) : null;
                    if (endDate && isNaN(endDate.getTime())) endDate = null;
                    return {
                        ...job,
                        job_title: job.title,
                        openings: job.openings,
                        shortlisted: job.Potential,
                        offer_released: job['Offer Released'],
                        joined: job['Placement Closed'],
                        start_date: startDate,
                        end_date: endDate,
                        owner_id: job.created_by,
                        received: job.Received,
                        Technical_Interview: job["Technical Interview"],
                        Submitted: job.Submitted,
                        Interviews: job.Interviews,
                        Offer_Accepted: job["Offer Accepted"],
                        Offer_Rejected: job["Offer Rejected"],
                        Placement_Closed: job["Placement Closed"]
                    };
                });
                setJobs(apiResponse);
                setLoading(false);
                setTotalRecords(response?.data?.count || 0);
            } else {
                triggerAlert('error', "Something Went Wrong");
            }
        } catch (error) {
            console.log("error", error.message);
            setLoading(false);
            triggerAlert('error', error.message);
        }
    };

    // useEffect(() => {
    //     const page = Math.floor(first / rows) + 1;
    //     fetchActiveJobSummaryResults(page);
    // }, [first, rows]);


    const [pageSize, setPageSize] = useState(5);
    useEffect(() => {
        // const currentPage = Math.floor(first / rows) + 1;
        fetchActiveJobSummaryResults(1);
    }, [companyId, pageSize]);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 1,
    });

    const handlePageChange = (event) => {
        const { first, rows } = event;
        const page = Math.floor(first / rows) + 1;
        setLazyParams({ first, rows, page });
        fetchActiveJobSummaryResults(page, rows, companyId);
    };
    const exportCSV = () => {
        if (selectedJobs.length > 0) {
            dt.current.exportCSV({ selectionOnly: true });
        } else {
            dt.current.exportCSV({ selectionOnly: false });

            if (toast.current) {
                toast.current.show({
                    severity: 'info',
                    summary: 'Info',
                    detail: 'No rows selected, exporting all data.',
                    life: 3000
                });
            }
        }
    };


    // const exportPdf = () => {
    //     import("jspdf").then((jsPDF) => {
    //         import("jspdf-autotable").then(() => {
    //             const doc = new jsPDF.default();
    //             const exportColumns = columnConfig.map(col => ({
    //                 title: col.header,
    //                 dataKey: col.field
    //             }));
    //             const formattedData = (selectedJobs.length > 0 ? selectedJobs : jobs).map(job => ({
    //                 ...job,
    //                 start_date: job.start_date.toLocaleDateString('en-GB', {
    //                     day: '2-digit',
    //                     month: '2-digit',
    //                     year: 'numeric'
    //                 }),
    //                 end_date: job.end_date.toLocaleDateString('en-GB', {
    //                     day: '2-digit',
    //                     month: '2-digit',
    //                     year: 'numeric'
    //                 })
    //             }));
    //             doc.autoTable({
    //                 columns: exportColumns,
    //                 body: formattedData
    //             });
    //             doc.save("jobs.pdf");
    //             if (selectedJobs.length === 0 && toast.current) {
    //                 toast.current.show({
    //                     severity: 'info',
    //                     summary: 'Info',
    //                     detail: 'No rows selected, exporting all data.',
    //                     life: 3000
    //                 });
    //             }
    //         });
    //     }).catch((error) => {
    //         console.error('Error exporting to PDF:', error);
    //         if (toast.current) {
    //             toast.current.show({
    //                 severity: 'error',
    //                 summary: 'Error',
    //                 detail: 'An error occurred while exporting to PDF.',
    //                 life: 4000
    //             });
    //         }
    //     });
    // };

    const exportPdf = () => {
        import("jspdf").then((jsPDF) => {
            import("jspdf-autotable").then(() => {
                const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;

                if (dataToExport.length === 0) {
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'No data available for export.',
                            life: 4000
                        });
                    }
                    return;
                }

                const doc = new jsPDF.default("landscape");
                const exportColumns = columnConfig.map(col => ({
                    title: col.header,
                    dataKey: col.field
                }));

                const formattedData = dataToExport.map(job => {
                    const row = {};
                    columnConfig.forEach(col => {
                        row[col.field] = col.field === 'start_date' || col.field === 'end_date'
                            ? (job[col.field] ? `${job[col.field].getFullYear()}-${String(job[col.field].getMonth() + 1).padStart(2, '0')}-${String(job[col.field].getDate()).padStart(2, '0')}` : '-')
                            : job[col.field] ?? '-';
                    });
                    return row;
                });

                doc.autoTable({
                    columns: exportColumns,
                    body: formattedData,
                    startY: 20,
                    styles: { fontSize: 8, cellPadding: 2 },
                    theme: "grid",
                    margin: { top: 10, left: 5, right: 5 },
                    columnStyles: { 0: { cellWidth: 30 } }
                });

                doc.save("jobs.pdf");
                if (selectedJobs.length === 0 && toast.current) {
                    toast.current.show({
                        severity: 'info',
                        summary: 'Info',
                        detail: 'No rows selected, exporting all data.',
                        life: 3000
                    });
                }
            });
        }).catch((error) => {
            console.error('Error exporting to PDF:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while exporting to PDF.',
                    life: 4000
                });
            }
        });
    };
    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;
            const formattedData = dataToExport.map(job => {
                const row = {};
                columnConfig.forEach(col => {
                    row[col.header] = col.field === 'start_date' || col.field === 'end_date'
                        ? (job[col.field] ? `${job[col.field].getFullYear()}-${String(job[col.field].getMonth() + 1).padStart(2, '0')}-${String(job[col.field].getDate()).padStart(2, '0')}` : '-')
                        : job[col.field] ?? '-';
                });
                return row;
            });
            const worksheet = xlsx.utils.json_to_sheet(formattedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, selectedJobs.length > 0 ? 'selected_jobs' : 'all_jobs');
            if (selectedJobs.length === 0 && toast.current) {
                toast.current.show({
                    severity: 'info',
                    summary: 'Info',
                    detail: 'No rows selected, exporting all data.',
                    life: 3000
                });
            }
        }).catch((error) => {
            console.error('Error exporting to Excel:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while exporting to Excel.',
                    life: 4000
                });
            }
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], { type: EXCEL_TYPE });
        saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };

    const printFile = () => {
        const exportColumns = columnConfig.map(col => ({
            title: col.header,
            dataKey: col.field
        }));

        const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;

        if (selectedJobs.length === 0 && toast.current) {
            toast.current.show({
                severity: 'info',
                summary: 'Info',
                detail: 'No rows selected, printing all data.',
                life: 3000
            });
        }

        const tableHeaders = exportColumns
            .map(col => `<th style="border: 1px solid #ccc; padding: 10px; background-color: #f5f5f5; font-weight: bold;">${col.title}</th>`)
            .join('');

        const tableRows = dataToExport.length > 0
            ? dataToExport
                .map(row => {
                    if (!row) return '';
                    return `<tr>${exportColumns
                        .map(col => `<td style="border: 1px solid #ccc; padding: 10px;">${col.dataKey === 'start_date' || col.dataKey === 'end_date'
                            ? (row[col.dataKey] ? `${row[col.dataKey].getFullYear()}-${String(row[col.dataKey].getMonth() + 1).padStart(2, '0')}-${String(row[col.dataKey].getDate()).padStart(2, '0')}` : '-')
                            : (row[col.dataKey] ?? '-')
                            }</td>`)
                        .join('')}</tr>`;
                })
                .filter(row => row)
                .join('')
            : '<tr><td colspan="12" style="border: 1px solid #ccc; padding: 10px; text-align: center;">No data available</td></tr>';

        const timestamp = new Date().toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        const htmlContent = `
            <html>
            <head>
                <title>Active Job Summary Report - ${timestamp}</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 2cm;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        margin-top: 20px;
                    }
                    th, td {
                        border: 1px solid #ccc;
                        padding: 12px;
                        text-align: left;
                        font-size: 14px;
                    }
                    th {
                        background-color: #e6e6e6;
                        color: #333;
                    }
                    h2 {
                        text-align: center;
                        font-size: 20px;
                        margin-bottom: 20px;
                        color: #333;
                    }
                    @media print {
                        body {
                            margin: 1cm;
                        }
                        table {
                            page-break-inside: auto;
                        }
                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                    }
                </style>
            </head>
            <body>
                <h2>Active Job Summary Report - ${timestamp}</h2>
                <table>
                    <thead><tr>${tableHeaders}</tr></thead>
                    <tbody>${tableRows}</tbody>
                </table>
            </body>
            </html>
        `;

        try {
            const printWindow = window.open('', '_blank', 'height=600,width=900');
            if (!printWindow) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to open print window. Please allow pop-ups.',
                        life: 4000
                    });
                }
                return;
            }
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            setTimeout(() => printWindow.close(), 500);
        } catch (error) {
            console.error('Error during printing:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while printing.',
                    life: 4000
                });
            }
        }
    };

    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                <Container fluid={true}>
                    <div className="page-title-box actjobbread">
                        <Row className="align-items-center actjobsum">
                            <Col sm={6} md={6} lg={8}>
                                <h1 className="page-title">Active Job Summary Report</h1>
                            </Col>
                            <Col sm={6} md={6} lg={4}>
                                <div className="allbtns d-flex gap-2 justify-content-end">
                                    <Button
                                        type="button"
                                        icon="pi pi-file"
                                        rounded
                                        onClick={exportCSV}
                                        tooltip={selectedJobs.length > 0 ? "Export Selected to CSV" : "Export All to CSV"}
                                        tooltipOptions={{ position: 'left' }}
                                        className="csvbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-file-excel"
                                        severity="success"
                                        rounded
                                        onClick={exportExcel}
                                        tooltip={selectedJobs.length > 0 ? "Export Selected to XLS" : "Export All to XLS"}
                                        tooltipOptions={{ position: 'top' }}
                                        className="xlsbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-file-pdf"
                                        severity="warning"
                                        rounded
                                        onClick={exportPdf}
                                        tooltip={selectedJobs.length > 0 ? "Export Selected to PDF" : "Export All to PDF"}
                                        tooltipOptions={{ position: 'bottom' }}
                                        className="pdfbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-print"
                                        severity="warning"
                                        rounded
                                        onClick={printFile}
                                        tooltip={selectedJobs.length > 0 ? "Print Selected" : "Print All"}
                                        tooltipOptions={{ position: 'bottom' }}
                                        className="printbtn"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xxl={6}>
                                <h1 className="page-title mb-4"> </h1>
                            </Col>
                            <Col xxl={6}>
                                <div className="d-flex justify-content-end mt-2">
                                    <label className="mt-2 me-2">Select Company</label>
                                    <div className="mb-2 me-2" style={{ width: "170px" }}>
                                        <CompanySelector onCompanyChange={handleCompanyChange} />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <Toast ref={toast} />
                                        {loading ? (
                                            <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                                        ) : (
                                            <DataTable
                                                showGridlines
                                                ref={dt}
                                                value={jobs}
                                                tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                                                // rows={rows}
                                                // first={first}
                                                onPage={handlePageChange}
                                                first={lazyParams.first}
                                                rows={lazyParams.rows}
                                                id="ActiveJobSummaryReport"
                                                // lazy
                                                paginator
                                                rowsPerPageOptions={[5, 10, 25, 50,totalRecords]}
                                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                // onPage={onPage}
                                                dataKey="job_number"
                                                filters={filters}
                                                onFilter={(e) => setFilters(e.filters)} 
                                                filterDisplay="row"
                                                loading={loading}
                                                globalFilterFields={columnConfig.map(col => col.field)}
                                                scrollable
                                                emptyMessage="No jobs found."
                                                selection={selectedJobs}
                                                onSelectionChange={onSelectionChange}
                                                selectionMode="checkbox"
                                                totalRecords={totalRecords}
                                                resizableColumns
                                                columnResizeMode="expand"
                                            >
                                                {/* <Column selectionMode="multiple" style={{ width: '3em' }} /> */}
                                                {columnConfig.map((col, index) => (
                                                    <Column
                                                        key={index}
                                                        field={col.field}
                                                        header={col.header}
                                                        sortable={col.sortable}
                                                        filter={col.filter}
                                                        filterPlaceholder={col.filterPlaceholder}
                                                        filterElement={col.filterElement}
                                                        body={col.body}
                                                        style={col.style}
                                                    />
                                                ))}
                                            </DataTable>
                                        )}
                                    </div>
                                </section>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ActiveJobSummary;
